import companyDetailsTemplate from './company_details.component.html';

const companyDetails = {
    templateUrl: companyDetailsTemplate.id,
    bindings: {
        company: '<',
        showName: '<'
    }
};
angular.module('BBPublicBooking').component('companyDetailsComponent', companyDetails);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/company-details/company_details.component.js